var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"work-flow"},[_c('img',{attrs:{"src":require('/src/assets/img/odc/work-flow.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }